// extracted by mini-css-extract-plugin
export default {"wrapper":"ExperienceList_wrapper__sLPr0","experienceLinkWrapper":"ExperienceList_experienceLinkWrapper__zaMWZ","experienceLink":"ExperienceList_experienceLink__VkQ-k"};